import platformDetails from '@/utils/platform-details'
import { browsersService } from '@/api'

const initialState = () => ({
  id: null,
  ua: null,
  os: null,
  name: null,
  layout: null,
  version: null,
  description: null
})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async assign({ commit, state }) {
      if (state.id) return state
      console.log('create browser')
      const browser = await browsersService.create(platformDetails.report())
      console.log('brwoser result', browser)
      commit('assign', browser)
      commit(
        'dots/active/browser/assign',
        {
          browser_id: browser.id
        },
        { root: true }
      )
      return browser
    }
  },
  mutations: {
    assign(
      state,
      {
        id = null,
        ua = null,
        os = null,
        name = null,
        layout = null,
        version = null,
        description = null
      } = {}
    ) {
      state.id = id
      state.ua = ua
      state.os = os
      state.name = name
      state.layout = layout
      state.version = version
      state.description = description
    },
    reset(state) {
      Object.assign(state, initialState())
    }
  }
}
